import * as Sentry from "@sentry/react";
import { containsOriginalDownloadUrl, omitOriginalDownloadTelemetry } from '@shared/originalDownloadTelemetry';
import { browserTracingIntegration } from "@sentry/react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { installRadixBodyLockGuard } from "@/lib/radixBodyLockGuard";
import { benchmarkTraceRate } from "@/lib/benchmarkAccounts";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [browserTracingIntegration()],
  tracesSampler: () => benchmarkTraceRate(0.2),
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  beforeSend: omitOriginalDownloadTelemetry,
  beforeSendTransaction: omitOriginalDownloadTelemetry,
  beforeBreadcrumb: omitOriginalDownloadTelemetry,
  beforeSendSpan: span => containsOriginalDownloadUrl(span)
    ? { ...span, description: 'Original image download', data: {} } : span,
});

installRadixBodyLockGuard();

const root = createRoot(document.getElementById("root")!);

// Fast path for fully public marketing routes: render the page directly
// without ever loading App.tsx (which statically imports ~50 page modules
// and would otherwise force Vite to compile everything before the page
// can render).
if (window.location.pathname.startsWith("/nada-signup")) {
  import("./pages/nada-ny").then(({ default: NadaNy }) => {
    import("@/components/ui/toaster").then(({ Toaster }) => {
      root.render(
        <Sentry.ErrorBoundary fallback={<div className="flex items-center justify-center min-h-screen text-sm text-muted-foreground">Something went wrong. Please refresh the page.</div>}>
          <Toaster />
          <NadaNy />
        </Sentry.ErrorBoundary>,
      );
    });
  });
} else {
  import("./App").then(({ default: App }) => {
    root.render(
      <Sentry.ErrorBoundary fallback={<div className="flex items-center justify-center min-h-screen text-sm text-muted-foreground">Something went wrong. Please refresh the page.</div>}>
        <App />
      </Sentry.ErrorBoundary>
    );
  });
}
